import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from '../molecules';
import { AdditionalOptionCard } from '../molecules';

const AdditionalOptionsSection = ({ className = "" }) => {
  const { t } = useTranslation();

  const options = [
    {
      title: "ตัวเลือกการต้อนรับแบบพรีเมียม",
      description: "อาหารและเครื่องดื่มในรถ, บริการถ่ายภาพที่ระลึก, พร้อมไกด์ทัวร์",
      price: "+10,000 เยน～",
      features: [
        "การจัดอาหารและเครื่องดื่ม",
        "ช่างภาพส่วนตัว",
        "ไกด์นำเที่ยว",
        "ของขวัญที่ระลึก"
      ]
    },
    {
      title: "ตัวเลือกโฟกัสทางธุรกิจ",
      description: "พื้นที่ประชุมในรถ, Wi-Fi, อุปกรณ์ชาร์จ, มาตรการรักษาความลับ",
      price: "+8,000 เยน～",
      features: [
        "การตั้งค่าการประชุมในรถ",
        "Wi-Fi ความเร็วสูง",
        "การชาร์จหลายพอร์ต",
        "ข้อตกลงการรักษาความลับ"
      ]
    },
    {
      title: "สนับสนุนกิจกรรมพิเศษ",
      description: "การจัดงานสำหรับวันพิเศษเช่นงานแต่งงาน วันครบรอบ กิจกรรมองค์กร",
      price: "+15,000 เยน～",
      features: [
        "การตกแต่งพิเศษ",
        "การดูแลระดับวีไอพี",
        "การสนับสนุนการดำเนินกิจกรรม",
        "การบันทึกภาพและวิดีโอ"
      ]
    }
  ];

  return (
    <section className={`py-16 bg-gradient-to-br from-blue-50 to-indigo-100 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          badge="ตัวเลือกเสริม"
          title="สำหรับผู้ที่ต้องการประสบการณ์พิเศษเพิ่มเติม"
          subtitle="ปรับแต่งตามความต้องการของคุณ"
          className="text-center mb-12"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {options.map((option, index) => (
            <AdditionalOptionCard
              key={index}
              option={option}
              className="h-full"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdditionalOptionsSection;
